/* eslint-disable @typescript-eslint/no-use-before-define */
import {
    Action,
    ActionReducerMap,
    createFeatureSelector,
    createSelector,
    StoreModule,
} from '@ngrx/store';
import { TrackedRide } from '@polaris-customerweb/sharedcomponents.user-content';
import {
    DeleteTrackedRide,
    ForceTrackedRideRefresh,
    SetActiveTrackedRide,
    SetIsTrackedRideEditing,
    SetTrackedRides,
    ToggleActiveTrackedRide,
    TrackedRideAction,
    UpdateTrackedRide,
} from './tracked-ride.actions';

export interface TrackedRideState {
    activeTrackedRide?: TrackedRide;
    forceRefresh: boolean;
    trackedRides: TrackedRide[];
    isTrackedRideEditing: boolean;
}

const reducerMap: ActionReducerMap<TrackedRideState> = {
    activeTrackedRide: activeTrackedRideReducer,
    forceRefresh: forceRefreshReducer,
    isTrackedRideEditing: isTrackedRideEditingReducer,
    trackedRides: trackedRidesReducer,
};

export const selectTrackedRideState =
    createFeatureSelector<TrackedRideState>('trackedRide');
export const selectActiveTrackedRide = createSelector(
    selectTrackedRideState,
    (state) => state.activeTrackedRide
);
export const selectTrackedRides = createSelector(
    selectTrackedRideState,
    (state) => state.trackedRides
);
export const selectShouldForceTrackedRideRefresh = createSelector(
    selectTrackedRideState,
    (state) => state.forceRefresh
);
export const selectIsTrackedRideEditing = createSelector(
    selectTrackedRideState,
    (state) => state.isTrackedRideEditing
);

export const trackedRideStoreModule = StoreModule.forFeature(
    'trackedRide',
    reducerMap
);

function activeTrackedRideReducer(state: TrackedRide, action: Action) {
    switch (action.type) {
        case TrackedRideAction.setActiveTrackedRide:
            return (action as SetActiveTrackedRide).trackedRide;
        case TrackedRideAction.toggleActiveTrackedRide:
            if (
                (action as ToggleActiveTrackedRide).trackedRide?.id === state.id
            ) {
                return undefined;
            }

            return (action as ToggleActiveTrackedRide).trackedRide;
        default:
            return state;
    }
}

function forceRefreshReducer(state = true, action: Action) {
    switch (action.type) {
        case TrackedRideAction.forceTrackedRideRefresh:
            return (action as ForceTrackedRideRefresh).forceRefresh;
        default:
            return state;
    }
}

function trackedRidesReducer(state: TrackedRide[] = [], action: Action) {
    switch (action.type) {
        case TrackedRideAction.deleteTrackedRide:
            return state.filter(
                (trackedRide) =>
                    trackedRide.id !==
                    (action as DeleteTrackedRide).trackedRideId
            );
        case TrackedRideAction.setTrackedRides:
            return (action as SetTrackedRides).trackedRides;
        case TrackedRideAction.updateTrackedRide:
            return [
                ...state.filter(
                    (trackedRide) =>
                        trackedRide.id !==
                        (action as UpdateTrackedRide).trackedRide.id
                ),
                (action as UpdateTrackedRide).trackedRide,
            ];
        default:
            return state;
    }
}

function isTrackedRideEditingReducer(state = false, action: Action) {
    switch (action.type) {
        case TrackedRideAction.setIsTrackedRideEditing:
            return (action as SetIsTrackedRideEditing).isTrackedRideEditing;
        default:
            return state;
    }
}
